export default __webpack_public_path__ + "static/media/dev.d0535225.png";